module.exports = "https://web-assets.ifttt.com/packs/media/applet_card/user-icon-00be76dc.svg";